import React from "react"
import DashboardComponent from "../components/Dashboard/Dashboard"

const DashboardView = () => <DashboardComponent />

export default DashboardView
